import { AcroNode } from "./types";
import { escapeHtml } from "./escapeHtml";

export function renderEditText(node: AcroNode): string {
  const id = escapeHtml(String(node.id ?? ""));
  // const idRaw = String(node.id ?? "");
  const fieldId = node.field_id ? escapeHtml(String(node.field_id)) : "";
  const title = node.title ? escapeHtml(String(node.title)) : "";
  const titleRaw = String(node.title ?? "");
  let placeholderRaw = String(node.placeholder ?? "");
  // If placeholder contains only non-alphanumeric symbols, replace with empty string
  if (!/[a-zA-Z0-9]/.test(placeholderRaw)) {
    placeholderRaw = "";
  }
  const placeholder = escapeHtml(placeholderRaw);
  const multiline = !!node.multiline;
  const label = title ? `<label class="text-sm text-gray-700">${title}</label>` : "";
  const fieldIdAttr = fieldId ? ` data-field-id="${fieldId}"` : "";
  const isEditText = String(node.type ?? "").toLowerCase() === "edittext";
  const isDateField = isEditText && titleRaw.toLowerCase().includes("date");
  const isSignatureField = isEditText && titleRaw.toLowerCase().includes("signature");
  const inputType = isDateField ? "date" : "text";
  const dataType = isSignatureField ? "signature" : inputType;
  const dataLabelAttr = titleRaw.toLowerCase().includes("mail code") ? ' data-label="mail_code"' : '';
  const input = multiline
    ? `<textarea data-id="${id}"${fieldIdAttr}${dataLabelAttr} class="form-textarea w-full" placeholder="${placeholder}"></textarea>`
    : `<input type="${inputType}" data-type="${dataType}" data-id="${id}"${fieldIdAttr}${dataLabelAttr} class="form-input w-full" placeholder="${placeholder}" />`;
  return `<div class="label-input-wrapper flex flex-col gap-2">${label}${input}</div>`;
}

export function renderEditTextInputOnly(node: AcroNode): string {
  const id = escapeHtml(String(node.id ?? ""));
  // const idRaw = String(node.id ?? "");
  const fieldId = node.field_id ? escapeHtml(String(node.field_id)) : "";
  const titleRaw = String(node.title ?? "");
  let placeholderRaw = String(node.placeholder ?? "");
  // If placeholder contains only non-alphanumeric symbols, replace with empty string
  if (!/[a-zA-Z0-9]/.test(placeholderRaw)) {
    placeholderRaw = "";
  }
  const placeholder = escapeHtml(placeholderRaw);
  const multiline = !!node.multiline;
  const fieldIdAttr = fieldId ? ` data-field-id="${fieldId}"` : "";
  const isEditText = String(node.type ?? "").toLowerCase() === "edittext";
  const isDateField = isEditText && titleRaw.toLowerCase().includes("date");
  const isSignatureField = isEditText && titleRaw.toLowerCase().includes("signature");
  const inputType = isDateField ? "date" : "text";
  const dataType = isSignatureField ? "signature" : inputType;
  return multiline
    ? `<textarea data-id="${id}"${fieldIdAttr} class="form-textarea w-full" placeholder="${placeholder}"></textarea>`
    : `<input type="${inputType}" data-type="${dataType}" data-id="${id}"${fieldIdAttr} class="form-input w-full" placeholder="${placeholder}" />`;
}
